import { Button, ButtonColor, ButtonSize } from '@code/innovance-react-ui-kit';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormElement, FormRow } from 'src/front/components/FormStyles';
import styled from 'styled-components';
import FormModal from './FormModal';

enum StaticLinks {
  'WEBSITE' = 'https://www.crediteurope.ru/',
  'INFORMATION_SECURITY' = 'https://www.crediteurope.ru/upload/files/privately/docs/Users%20manual_V2.pdf',
  'IB_RATES' = 'https://online.crediteurope.ru/FWFIB/tariffs_ru.html',
  'FAQ_SECURITY' = 'https://www.crediteurope.ru/upload/files/privately/docs/Frequently_asked_questions_FAQ_RU.pdf',
}
enum StaticLinkTranslationKeys {
  'WEBSITE' = 'callCenter_internetBanking_links_cebWebsite_text',
  'INFORMATION_SECURITY' = 'callCenter_internetBanking_links_informationSecurityGuide_text',
  'IB_RATES' = 'callCenter_internetBanking_links_ibRates_text',
  'FAQ_SECURITY' = 'callCenter_internetBanking_links_faqOnInformationSecurity_text',
}

const EndFormRow = styled.div`
  position: absolute;
  right: 290px;
`;
const Link = styled(Button)`
  border: none;
  align-content: flex-start;

  text-align: start;
`;
const clickLink = (link: StaticLinks): void => {
  window.open(link);
};
const QuickLinks: FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);

  const setModalClose = (): void => {
    setModalOpen(false);
  };
  return (
    <>
      {isModalOpen ? (
        <FormModal onClose={setModalClose}>
          <FormRow>
            <FormElement>
              <Link
                color={ButtonColor.Secondary}
                onClick={() => clickLink(StaticLinks.WEBSITE)}
                size={ButtonSize.Large}
                text={t(StaticLinkTranslationKeys.WEBSITE)}
              />
            </FormElement>
          </FormRow>
          <FormRow>
            <FormElement>
              <Link
                color={ButtonColor.Secondary}
                onClick={() => clickLink(StaticLinks.INFORMATION_SECURITY)}
                size={ButtonSize.Large}
                text={t(StaticLinkTranslationKeys.INFORMATION_SECURITY)}
              />
            </FormElement>
          </FormRow>
          <FormRow>
            <FormElement>
              <Link
                color={ButtonColor.Secondary}
                onClick={() => clickLink(StaticLinks.IB_RATES)}
                size={ButtonSize.Large}
                text={t(StaticLinkTranslationKeys.IB_RATES)}
              />
            </FormElement>
          </FormRow>
          <FormRow>
            <FormElement>
              <Link
                color={ButtonColor.Secondary}
                onClick={() => clickLink(StaticLinks.FAQ_SECURITY)}
                size={ButtonSize.Large}
                text={t(StaticLinkTranslationKeys.FAQ_SECURITY)}
              />
            </FormElement>
          </FormRow>
        </FormModal>
      ) : null}
      <EndFormRow>
        <Button
          color={ButtonColor.Secondary}
          onClick={() => setModalOpen(true)}
          size={ButtonSize.Medium}
          text={t('general_components_links_text')}
        />
      </EndFormRow>
    </>
  );
};
export default QuickLinks;
